<!-- Resumen desktop: cada segmento abre su selector; la flecha abre el panel completo -->
<div class="ctx-switcher" [class.is-open]="panelOpen">
    <div class="ctx-seg ctx-seg-empresa" [class.ctx-seg-static]="!canSelectCompany" role="button" tabindex="0"
         (click)="openSegment('empresa', $event)" (keydown.enter)="openSegment('empresa', $event)">
        <small>Empresa</small>
        <span>{{companySelected?.razonSocial}}</span>
    </div>
    <div class="ctx-seg" role="button" tabindex="0"
         (click)="openSegment('sede', $event)" (keydown.enter)="openSegment('sede', $event)">
        <small>Sede</small>
        <span>{{office?.nombre || '—'}}</span>
    </div>
    <div class="ctx-seg" role="button" tabindex="0"
         (click)="openSegment('estacion', $event)" (keydown.enter)="openSegment('estacion', $event)">
        <small>Estación</small>
        <span>{{saleStation?.nombre || '—'}}</span>
    </div>
    <div class="ctx-caret" role="button" tabindex="0" pTooltip="Contexto de venta" tooltipPosition="bottom"
         (click)="open($event)" (keydown.enter)="open($event)">
        <i class="pi pi-chevron-down"></i>
    </div>
</div>

<!-- un overlay por segmento: abrir uno nuevo no queda bloqueado por la
     animación de cierre del anterior (mismo click cierra y abre) -->
<p-overlayPanel #segPanelEmpresa styleClass="ctx-seg-panel" appendTo="body">
    <ng-template pTemplate>
        <ng-container *ngTemplateOutlet="segList"></ng-container>
    </ng-template>
</p-overlayPanel>
<p-overlayPanel #segPanelSede styleClass="ctx-seg-panel" appendTo="body">
    <ng-template pTemplate>
        <ng-container *ngTemplateOutlet="segList"></ng-container>
    </ng-template>
</p-overlayPanel>
<p-overlayPanel #segPanelEstacion styleClass="ctx-seg-panel" appendTo="body">
    <ng-template pTemplate>
        <ng-container *ngTemplateOutlet="segList"></ng-container>
    </ng-template>
</p-overlayPanel>

<ng-template #segList>
    <div class="ctx-seg-list">
        <small class="ctx-seg-list-title">{{segTitle}}</small>
        <div class="ctx-seg-loading" *ngIf="segMode === 'estacion' && loadingStations">
            <i class="pi pi-spin pi-spinner"></i> Cargando…
        </div>
        <button type="button" class="ctx-seg-option" *ngFor="let item of segOptions"
                [class.is-current]="isCurrentSegItem(item)" (click)="selectSegItem(item)">
            <span>{{segLabel(item)}}</span>
            <i class="pi pi-check" *ngIf="isCurrentSegItem(item)"></i>
        </button>
    </div>
</ng-template>

<!-- Chip compacto para móvil -->
<div class="ctx-chip" role="button" tabindex="0" (click)="open($event)" (keydown.enter)="open($event)">
    <span>{{office?.nombre || '—'}}<ng-container *ngIf="saleStation"> · {{saleStation?.nombre}}</ng-container></span>
    <i class="pi pi-chevron-down"></i>
</div>

<p-overlayPanel #panel styleClass="ctx-panel" (onHide)="onPanelHide()">
    <ng-template pTemplate>
        <div class="ctx-form">
            <ng-container *ngTemplateOutlet="ctxHeader"></ng-container>
            <ng-container *ngTemplateOutlet="ctxFields"></ng-container>
            <ng-container *ngTemplateOutlet="ctxActions"></ng-container>
        </div>
    </ng-template>
</p-overlayPanel>

<p-sidebar [(visible)]="sheetVisible" position="bottom" styleClass="ctx-sheet" [blockScroll]="true" appendTo="body">
    <div class="ctx-form">
        <ng-container *ngTemplateOutlet="ctxHeader"></ng-container>
        <ng-container *ngTemplateOutlet="ctxFields"></ng-container>

        <div class="ctx-sec" *ngIf="printerVisible || whatsappVisible">
            <small class="ctx-sec-title">Dispositivos</small>
            <div class="ctx-dev" *ngIf="printerVisible">
                <i class="pi pi-print"></i>
                <span>Impresión</span>
                <span class="ctx-dev-status" [class.is-ok]="printerConnected" [class.is-off]="!printerConnected">
                    {{printerConnected ? 'Equipo conectado' : 'Sin equipos conectados'}}
                </span>
                <button type="button" class="ctx-dev-link" aria-label="Ver equipos de impresión" aria-haspopup="dialog"
                        (click)="close(); printerClick.emit()">Ver equipos</button>
            </div>
            <small class="ctx-dev-hint" *ngIf="printerVisible">
                Estado de impresión de la sede activa de Teki: {{office?.nombre || office?.codigo || 'sin sede seleccionada'}}.
            </small>
            <div class="ctx-dev" *ngIf="whatsappVisible">
                <i class="pi pi-whatsapp"></i>
                <span>WhatsApp</span>
                <span class="ctx-dev-status" [class.is-ok]="whatsappConnected" [class.is-off]="!whatsappConnected">
                    {{whatsappConnected ? 'Sesión activa' : 'Sin sesión'}}
                </span>
                <a *ngIf="!whatsappConnected && whatsappRoute" [routerLink]="whatsappRoute" (click)="close()">Conectar</a>
            </div>
        </div>

        <div class="ctx-sec" *ngIf="shortcuts?.length">
            <small class="ctx-sec-title">Accesos directos</small>
            <div class="ctx-chips">
                <a class="ctx-qchip" *ngFor="let item of shortcuts" [routerLink]="item?.ruta" (click)="close()">
                    <span *ngIf="item?.icono?.startsWith('fa')" [class]="item.icono"></span>
                    <i *ngIf="item?.icono?.startsWith('pi')" [class]="item.icono"></i>
                    {{item?.nombre}}
                </a>
            </div>
        </div>

        <ng-container *ngTemplateOutlet="ctxActions"></ng-container>
    </div>
</p-sidebar>

<ng-template #ctxHeader>
    <h5 class="ctx-title">Contexto de venta</h5>
    <p class="ctx-subtitle">Todo lo que registres se guardará aquí. Los cambios se aplican al instante.</p>
</ng-template>

<ng-template #ctxFields>
    <div class="ctx-field">
        <label>Empresa</label>
        <p-dropdown *ngIf="canSelectCompany; else empresaFija"
                    dataKey="id" [options]="attachedCompanies" [(ngModel)]="empresaSel"
                    optionLabel="razonSocial" (onChange)="onEmpresaChange()"
                    appendTo="body" [style]="{'width':'100%'}"></p-dropdown>
        <ng-template #empresaFija>
            <div class="ctx-static">{{empresaSel?.razonSocial}}</div>
        </ng-template>
        <small>Razón social que emite tus comprobantes.</small>
    </div>

    <div class="ctx-field">
        <label>Sede / Punto de venta</label>
        <p-dropdown dataKey="id" [options]="offices" [(ngModel)]="officeSel"
                    optionLabel="nombre" (onChange)="onOfficeChange()"
                    appendTo="body" [style]="{'width':'100%'}"></p-dropdown>
        <small>Local donde se realiza la venta.</small>
    </div>

    <div class="ctx-field">
        <label>Estación</label>
        <p-dropdown dataKey="id" [options]="stations" [(ngModel)]="stationSel"
                    optionLabel="nombre" (onChange)="onStationChange()" [disabled]="loadingStations"
                    [placeholder]="loadingStations ? 'Cargando…' : 'Seleccione'"
                    appendTo="body" [style]="{'width':'100%'}"></p-dropdown>
        <small>Caja o equipo desde el que vendes.</small>
    </div>

    <div class="ctx-notice" *ngIf="canSelectCompany">
        <i class="pi pi-info-circle"></i>
        <span>Al cambiar de empresa, la sede y la estación se ajustan a las asignadas.</span>
    </div>
</ng-template>

<ng-template #ctxActions>
    <div class="ctx-actions">
        <button pButton type="button" label="Listo" (click)="close()"></button>
    </div>
</ng-template>
